import { ShowFlash } from 'ng2/shared/flash/store/flash.actions';
import { authenticatedPatientSelector, currentPatientSelector } from '../../../../main/selectors/patients-selectors.ts';

module.exports = {
  templateUrl: 'profile/components/tabs/change-email/change-email.html',
  controller: class ChangeEmail {

    static $inject = [
      '$ngRedux',
      '$scope',
      'PatientsService',
      'RegistrationService',
      'SecurityService',
    ];

    constructor($ngRedux, $scope, PatientsService, RegistrationService, SecurityService) {
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.PatientsService = PatientsService;
      this.RegistrationService = RegistrationService;
      this.SecurityService = SecurityService;
    }

    $onInit() {
      this.showModal = false;
      this.email = '';
      this.password = '';
      this.initializeStateConnection();

      this.noServerErrors = {
        newEmail: {},
      };
      this.resetServerErrors();
    }

    initializeStateConnection() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        authenticatedPatient: authenticatedPatientSelector(state),
        group: state.group,
        patient: currentPatientSelector(state),
        isHospitalBooking: state.hospitalBooking.isHospitalBooking,
      }))(this));
    }

    submit() {
      this.resetServerErrors();
      if (this.form.$valid) {
        this.submitting = true;
        this.showConfirmation();
      }
    }

    cancel() {
      this.resetForm();
    }

    verifyChangeAvailability() {
      this.PatientsService.checkChangeAvailability().then((response) => {
        if (response.data) {
          this.confirm();
        } else {
          this.hideConfirmation();
          this.openModal();
        }
      });
    }

    confirm() {
      this.hideConfirmation();
      this.PatientsService.changeEmail(this.authenticatedPatient.id, this.group.id, this.newEmail)
        .then(this.changeUnconfirmedEmailSuccess, this.changeUnconfirmedEmailError);
    }

    cancelConfirmation() {
      this.submitting = false;
      this.resetForm();
      this.hideConfirmation();
    }

    openModal() {
      this.showModal = true;
    }

    closeModal() {
      this.submitting = false;
      this.showModal = false;
      this.resetLoginForm();
    }

    login() {
      this.SecurityService.authenticate(this.email, this.password, this.mode === 'kiosk').then(() => {
        this.closeModal();
        this.verifyChangeAvailability();
      });
    }

    hideConfirmation() {
      this.showConfirmationPanel = false;
    }

    showConfirmation() {
      this.showConfirmationPanel = true;
    }

    changeUnconfirmedEmailSuccess = () => {
      this.submitting = false;
      this.resetForm();

      this.PatientsService.loadPatient(this.authenticatedPatient.id).then((authenticatedPatient) => {
        this.$ngRedux.dispatch(new ShowFlash({ name: 'update-email', additionalInfos: { newEmail: authenticatedPatient.unconfirmedEmail } }));
      });
    };

    changeUnconfirmedEmailError = (error) => {
      this.submitting = false;
      if (error.status === 400 && error.data.error.msg === 'Email already taken') {
        this.serverErrors.newEmail.alreadyTaken = true;
        this.form.newEmail.$setPristine();
      } else {
        this.$ngRedux.dispatch(new ShowFlash({ name: 'error' }));
        this.resetForm();
      }
    };

    resetForm() {
      this.newEmail = '';
      this.confirmNewEmail = '';
      this.form.$setPristine();
      this.form.$setUntouched();
      this.resetServerErrors();
    }

    resetLoginForm() {
      this.email = '';
      this.password = '';
      this.loginForm.$setPristine();
      this.loginForm.$setUntouched();
      this.resetServerErrors();
    }

    hasError(field) {
      return (this.form && this.form[field] && this.form[field].$invalid && (this.form[field].$touched || this.form.$submitted))
        || (!_.isEmpty(this.serverErrors[field]) && this.form[field].$pristine);
    }

    pendingConfirmation() {
      return this.authenticatedPatient.unconfirmedEmail !== null;
    }

    pendingEmail() {
      return this.authenticatedPatient.unconfirmedEmail;
    }

    currentEmail() {
      return this.patient.email;
    }

    resetServerErrors() {
      this.serverErrors = angular.copy(this.noServerErrors);
    }

    getClinics() {
      return this.patient.clinics;
    }

    canSubmit() {
      return this.RegistrationService.canSubmit(this.loginForm);
    }

    hasErrors(ngModel) {
      return this.loginForm && this.loginForm.$submitted && this.RegistrationService.hasErrors(ngModel);
    }
  },
};



// WEBPACK FOOTER //
// ./profile/components/tabs/change-email/change-email.js